<p-tabView *ngIf="entidade">
  <p-tabPanel header="Assunto">
    <div class="p-fluid">
      <div class="p-grid">
        <div class="p-col-12 p-lg-2">
          <label for="id">Id:</label>
        </div>
        <div class="p-col-12 p-lg-10">
          <input pInputText type="text" name="id" disabled [ngModel]="entidade.id" />
        </div>
      </div>
      <div class="p-grid">
        <div class="p-col-12 p-lg-2">
          <label for="nome">Descrição:</label>
        </div>
        <div class="p-col-12 p-lg-10">
          <input pInputText type="text" name="descricao" disabled [ngModel]="entidade.descricao" />
        </div>
      </div>
      <div class="p-grid">
        <div class="p-col-12 p-lg-2">
          <label for="nome">Situação:</label>
        </div>
        <div class="p-col-12 p-lg-10">
          <input pInputText type="text" name="situacao" disabled [ngModel]="entidade.situacao" />
        </div>
      </div>
      <div class="p-grid">
        <div class="p-col-12 p-lg-2">
          <label for="nome">Hierarquia:</label>
        </div>
        <div class="p-col-12 p-lg-10">
          <input pInputText type="text" name="hierarquia" disabled [ngModel]="entidade.hierarquia" />
        </div>
      </div>
      <div class="p-grid">
        <div class="p-col-12 p-lg-2">
          <label for="nome">Tipo:</label>
        </div>
        <div class="p-col-12 p-lg-10">
          <input pInputText type="text" name="tipoItem" disabled [ngModel]="entidade.tipoItem" />
        </div>
      </div>
      <div class="p-grid">
        <div class="p-col-12 p-lg-2">
          <label for="nome">Permitido:</label>
        </div>
        <div class="p-col-12 p-lg-10">
          <p-checkbox [(ngModel)]="entidade.permitido" binary="true"></p-checkbox>
        </div>
      </div>

    </div>
  </p-tabPanel>
</p-tabView>
